import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { asyncRoutes, constantRoutes } from "@/router";
import { getSubAccountNo, getIsCheckOpen } from "@/utils/auth";
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    //  判断登录账号是否为子账号登录 去掉子账号分配 路由
    var ischild = getSubAccountNo();
    if (route.meta.title == "子账号分配" && ischild == "1") {
      route.hidden = true;
    }
    //（普瑞/河北廊坊）系统不显示 《0-6岁视力分析》 
    if (route.meta.title == "0-6岁视力分析" && (process.env.VUE_APP_MODE == "pr" || process.env.VUE_APP_MODE == "hb")) {
      route.hidden = true;
    }
    //管理机构是否展示筛查管理
    var ischeckopen = getIsCheckOpen();
    if (route.meta.title == "筛查管理" && ischeckopen == "0" && roles == ['district']) {
      route.hidden = true;
    }
    // // 如果是疾控口并且是省级则不展示传染病监测，教育口展示传染病监测
    // if(route.meta.title == "传染病监测" && sessionStorage.getItem('login-from') == 'login' && roles.includes('province')){
    //   route.hidden = true;
    // }
    // 如果是教育口并且是区县级则不展示数据分析，疾控口展示数据分析
    if (route.meta.title == "数据分析" && sessionStorage.getItem('login-from') == 'loginedu' && roles.includes('district')) {
      route.hidden = true;
    }
    //标题是传染病监测和健康干预工作如果是疾控口并且是学校则不展示传染病和数据分析
    if ((route.meta.title == "传染病监测" || route.meta.title == "健康干预工作") && sessionStorage.getItem('login-from') == 'login' && roles.includes('schooladmin')) {
      route.hidden = true;
    }
    return roles.some(function (role) {
      return route.meta.roles.includes(role);
    });
  } else {
    return true;
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  var res = [];
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });
  return res;
}
var state = {
  routes: [],
  addRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    // state.routes = constantRoutes.concat(routes)
    //修改导航设置在顶部
    state.routes = routes.concat(constantRoutes);
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref, roles) {
    var commit = _ref.commit,
      rootState = _ref.rootState;
    var user = rootState.user;
    return new Promise(function (resolve) {
      var accessedRoutes;
      if (roles.includes("admin")) {
        accessedRoutes = asyncRoutes;
      } else {
        // 路由处理
        var paths = ["/setting/notificationManage"];
        if (user.currentInfo && user.currentInfo.is_show !== 1) {
          var newRoutes = asyncRoutes.map(function (route) {
            var newChildren = [];
            if (route.children && route.children.length > 0) {
              route.children.map(function (r) {
                if (!paths.includes(r.path)) {
                  newChildren.push(r);
                }
              });
            }
            return _objectSpread(_objectSpread({}, route), {}, {
              children: newChildren
            });
          });
          accessedRoutes = filterAsyncRoutes(newRoutes, roles);
        } else {
          accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
        }
      }
      commit("SET_ROUTES", accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};